import React, { useState, useEffect } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import Select from "react-select";
import { formatToIndianNumber, paymentMoethodOption } from "../../utilities";
import { updateBillApi } from "../../services/BillingService";

const BillingEditPaymnetModal = ({
  visible,
  onClose,
  onAfterSubmit,
  data = null,
}) => {
  const [loading, setLoading] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [form, setForm] = useState({
    paid_amount: "",
    payment_status: "PAID",
    payment_method: "",
  });
  const [error, setError] = useState({});
  useEffect(() => {
    if (visible) {
      handleReset();
    }
  }, [visible]);
  useEffect(() => {
    setForm({ ...form, payment_method: selectedPaymentMethod?.value || "" });
    if (error?.payment_method && selectedPaymentMethod?.value) {
      setError({ ...error, payment_method: "" });
    }
  }, [selectedPaymentMethod]);
  const handleReset = () => {
    setForm({
      paid_amount: "",
      payment_status: "PAID",
      payment_method: "",
    });
    setError({});
    setSelectedPaymentMethod(null);
  };

  const handleSubmit = () => {
    let error = {};
    if (!form.payment_status) error.payment_status = "Required Field";
    if (!form.payment_method) error.payment_method = "Required Field";
    if (form?.payment_status == "PARTIALLY_PAID") {
      if (!form.paid_amount) {
        error.paid_amount = "Required Field";
      } else if (
        Number(form.paid_amount) >=
        Number(data?.total || 0) - Number(data?.partial_amount || 0)
      ) {
        error.paid_amount = `Paid amount should less than ${
          Number(data?.total || 0) - Number(data?.partial_amount || 0)
        }`;
      }
    }

    setError(error);
    if (Object.keys(error).length === 0) {
      if (data) {
        updateBill();
      }
    }
  };

  const updateBill = () => {
    const { paid_amount, ...rest } = form;
    setLoading(true);
    updateBillApi(
      data?.id || "",
      form?.payment_status == "PAID"
        ? rest
        : { ...form, partial_amount: form?.paid_amount || 0 }
    )
      .then(() => {
        toast.success("Expense update successfully");
        onAfterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => setLoading(false));
  };

  return (
    <Modal show={visible} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Edit Payment</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="fw-semibold mb-2" style={{ fontSize: "0.95rem" }}>
          <span className="text-darker">Remaining Amount:</span>
          <span className="text-danger">
            ₹
            {formatToIndianNumber(
              Number(data?.total || 0) - Number(data?.partial_amount || 0) || 0
            )}
          </span>
        </div>
        <div className="row g-2 p-1">
          <div className="col-12 d-flex flex-column">
            {/* <label className="form-label text-dark">Payment Status</label> */}
            <div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="payment_status"
                  id="paid"
                  value="PAID"
                  checked={form.payment_status === "PAID"}
                  onChange={(e) => {
                    setForm((prev) => ({
                      ...prev,
                      payment_status: e.target.value,
                    }));
                    setError({ ...error, payment_status: "" });
                  }}
                />
                <label className="form-check-label" htmlFor="paid">
                  Full Paid
                </label>
              </div>

              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="payment_status"
                  id="partiallyPaid"
                  value="PARTIALLY_PAID"
                  checked={form.payment_status === "PARTIALLY_PAID"}
                  onChange={(e) => {
                    setForm((prev) => ({
                      ...prev,
                      payment_status: e.target.value,
                      paid_amount: "",
                    }));
                    setError({ ...error, payment_status: "" });
                  }}
                />
                <label className="form-check-label" htmlFor="partiallyPaid">
                  Partially Paid
                </label>
              </div>
            </div>
            {error?.payment_status && (
              <small className="text-danger">{error?.payment_status}</small>
            )}
          </div>
          <div className="col-12">
            <label className="form-label text-dark">Payment Method</label>
            <Select
              classNamePrefix="select"
              className="react-select"
              placeholder="Select payment mode"
              options={paymentMoethodOption}
              value={selectedPaymentMethod}
              onChange={setSelectedPaymentMethod}
            />
            {error?.payment_method && (
              <small className="text-danger">{error?.payment_method}</small>
            )}
          </div>

          {form.payment_status === "PARTIALLY_PAID" && (
            <div className="col-12">
              <label className="form-label text-dark">Paid Amount</label>
              <input
                type="text"
                name="paid_amount"
                className={`form-control ${
                  error?.paid_amount ? "is-invalid" : ""
                }`}
                value={form?.paid_amount}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    setForm({ ...form, paid_amount: value });

                    const total = Number(data?.total || 0);
                    const partial = Number(data?.partial_amount || 0);
                    const maxAllowed = total - partial;

                    if (Number(value) >= maxAllowed) {
                      setError((prev) => ({
                        ...prev,
                        paid_amount: `Paid amount must lessthan ${maxAllowed}`,
                      }));
                    } else {
                      setError((prev) => ({ ...prev, paid_amount: "" }));
                    }
                  }
                }}
                placeholder="Enter paid amount"
              />

              {error?.paid_amount && (
                <small className="text-danger">{error.paid_amount}</small>
              )}
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-end gap-2 w-100">
          <button
            className="btn btn-outline-dark"
            disabled={loading}
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading && <Spinner animation="border" size="sm" />}
            {data ? "Update" : "Submit"}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default BillingEditPaymnetModal;
